(function () {
  if (window.__r33fx) { window.__r33fx.scan(); return; }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fx = (window.__r33fx = {});
  var px = [];
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' })
    : null;
  function onScroll() {
    if (reduce || !px.length) return;
    var vh = window.innerHeight; 
    for (var i = 0; i < px.length; i++) {
      var el = px[i], r = el.getBoundingClientRect();
      var p = (vh - r.top) / (vh + r.height); p = p < 0 ? 0 : p > 1 ? 1 : p;
      var sp = parseFloat(el.getAttribute('data-speed')) || 60;
      el.style.transform = 'translateY(' + (sp * (1 - 2 * p)).toFixed(1) + 'px)';
    }
  }
  fx.scan = function () {
    document.querySelectorAll('.r33-reveal:not([data-seen])').forEach(function (el) {
      el.setAttribute('data-seen', '1'); if (io) io.observe(el); else el.classList.add('is-in');
    });
    if (!reduce) document.querySelectorAll('.r33-parallax:not([data-seen])').forEach(function (el) {
      el.setAttribute('data-seen', '1'); px.push(el);
    });
    onScroll();
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', function () { fx.scan(); });
  if (document.readyState !== 'loading') fx.scan();
  else document.addEventListener('DOMContentLoaded', fx.scan);
})();